import { API_EVENT } from '../config';
import { sendRequest } from '../send_request';
//
// Stores a Business Intelligence event
//
export const eventStoreRequest = async (jsonData) => {
   
    if (navigator && navigator.sendBeacon) {
        navigator.sendBeacon(API_EVENT.STORE_EVENT_URL, new Blob([jsonData], {type : 'application/json'}));
    } else {
        await sendRequest(API_EVENT.STORE_EVENT_URL, 'POST', jsonData, { keepalive: true });
    }

};